import styled from 'styled-components';
import {device} from '../../../styled/device';

export const ButtonsWrapperWarningModal = styled.div`
  font-family: Poppins-SemiBold, sans-serif;
  margin-top: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 30px;

  button {
    width: 225px;
  }
  a {
    font-size: 18px;
  }

  @media (max-width: ${device.mobileXL}) {
    margin-top: 60px;
  }
`;

export const ContainerWarningModal = styled.div``;

export const DescriptionWarningModal = styled.div`
  font-family: Poppins-Regular, sans-serif;
  font-size: 16px;
  padding: 0 6%;
  text-align: center;
`;

export const TitleWarningModal = styled.h1`
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 30px;
  padding: 0 6%;
  margin: 45px auto;
  text-align: center;
`;
